export let deferredPrompt = null

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault() // impede o prompt automático
  deferredPrompt = e
})
